import { PageContainer } from '@/components'
import styled from 'styled-components'
import { CreateTask } from './create-task'
const CreateWaf = () => (
  <PageContainer>
    <UserContainer>
      <HeaderTable>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div
            style={{
              borderRadius: '8px',
              background: '#fff',
            }}
          >
            <CreateTask />
          </div>
        </div>
      </HeaderTable>
    </UserContainer>
  </PageContainer>
)

export default CreateWaf
const UserContainer = styled.div`
  width: 100%;
  min-height: 100%;
  display: flex;
`

const HeaderTable = styled.div`
  //width: calc(100% - 330px);
  height: 100%;
  width: 100%;
  .header-table {
    max-width: 725px;
    display: flex;
    background-color: #fff;
    border-radius: 8px;
    margin-bottom: 18px;
    height: 36px;
    padding: 2px;
    .tab-item {
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 180px;
      border-radius: 8px;
      font-weight: bold;
      color: #333333;
    }
  }
  .scroll {
    padding-right: 20px !important;
  }
`
